<template>
  <ContentLayout
    widthClass="max-1000"
    :title="
      iSEdited
        ? $t('label_essweb_shiftType_form_editTitle')
        : $t('label_essweb_shiftType_form_viewTitle')
    "
    backgroundClass="white"
    :initData="shiftTypeData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'shift_type_name',
      'shift_type_code',
      'shift_type_abbr',
      'shift_type_description',
      'sequence',
    ]"
    :editBtn="!iSEdited"
    delBtn
    @delete="
      $confirmDo($t('label_essweb_shiftType_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
    @edit="iSEdited = true"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              maxlength="100"
              :readonly="!iSEdited"
              :bindData="shiftTypeData.shift_type_name"
              @change="
                (valueArr) => {
                  shiftTypeData.shift_type_name = valueArr;
                }
              "
              :label="$t('label_essweb_shiftType_form_typeNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="shiftTypeData.shift_type_abbr"
              maxlength="20"
              @change="
                (valueArr) => {
                  shiftTypeData.shift_type_abbr = valueArr;
                }
              "
              :label="$t('label_essweb_shiftType_form_typeAbbrLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :filled="iSEdited"
              :readonly="!iSEdited"
              v-model="shiftTypeData.shift_type_code"
              maxlength="20"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="$t('label_essweb_ClaimReason_form_codeLabel')"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              type="number"
              :filled="iSEdited"
              :readonly="!iSEdited"
              isNotRequire
              maxlength="255"
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 255])
              "
              :label="$t('label_essweb_shiftType_form_sequenceLabel')"
              v-model="shiftTypeData.sequence"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              maxlength="500"
              :readonly="!iSEdited"
              :bindData="shiftTypeData.shift_type_description"
              @change="
                (valueArr) => {
                  shiftTypeData.shift_type_description = valueArr;
                }
              "
              :label="$t('label_essweb_shiftType_form_descriptionLabel')"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        saveBtn
        @save="toSave"
        @cancel="toBack(isChanged)"
      />
    </template>
    <template v-slot:tools-main> </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editType",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      iSEdited: true,
      isChanged: false,
      shiftTypeData: {
        shift_type_name: "",
        shift_type_description: "",
        shift_type_abbr: "",
        shift_type_code: "",
        sequence: 1,
      },
    };
  },
  mounted() {
    const that = this;
    this.getShiftTypeDetailByUuid();
  },
  methods: {
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            this.$router.back();
          }
        });
      else {
        this.$router.back();
      }
    },
    getShiftTypeDetailByUuid: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_type",
        url: "/shift-type/get-shift-type-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["shift_type_name_save"] = res.data.shift_type_name;
        res.data.shift_type_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.shift_type_name
        );
        res.data["shift_type_description_save"] =
          res.data.shift_type_description;
        res.data.shift_type_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.shift_type_description
        );
        res.data["shift_type_abbr_save"] = res.data.shift_type_abbr;
        res.data.shift_type_abbr = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.shift_type_abbr
        );
        that.shiftTypeData = res.data;
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_type",
        url: "/shift-type/delete-shift-type-table/",
        data: { uuids: this.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_shiftType_list_deleteShiftTypeSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_shift_type",
        url: "/shift-type/update-shift-type-table/",
        data: {
          uuid: this.$route.params.id,
          shift_type_name: this.$transCommonLangKey(
            this.shiftTypeData.shift_type_name,
            this.shiftTypeData.shift_type_name_save
          ),
          shift_type_description: this.$transCommonLangKey(
            this.shiftTypeData.shift_type_description,
            this.shiftTypeData.shift_type_description_save
          ),
          shift_type_abbr: this.$transCommonLangKey(
            this.shiftTypeData.shift_type_abbr,
            this.shiftTypeData.shift_type_abbr_save
          ),
          shift_type_code: this.shiftTypeData.shift_type_code,
          sequence: this.shiftTypeData.sequence,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_shiftType_list_updateShiftTypeSuccessLabel"
          ),
          type: "success",
        });
        that.toBack(); //回到不能编辑状态
      });
    },
  },
};
</script>
